import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-r",
  "use": "icon-arrow-r-usage",
  "viewBox": "0 0 16 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 26\" id=\"icon-arrow-r\">\n  <path id=\"icon-arrow-r_arrow-r\" d=\"M16,13.033,3.321,26,.387,22.868,10.132,12.9,0,3.2,3.127,0,16,13.033Z\" fill=\"#c7c7cc\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol